import i18n from 'i18next';

export const formatResponseMessage = (message) => {
    if (Array.isArray(message)) {
        const errorMessage = message?.map((err) => i18n.t(err.DataKey, err.DataValues)).join('\n');
        return errorMessage;
    }
    return i18n.t(message);
};
